import PropTypes from 'prop-types'
import { memo, useCallback, useRef } from 'react'
import constants from 'app/constants'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import Button from 'components/core/Button/Button'
import ButtonAccountStatus from 'components/elements/ButtonAccountStatus/ButtonAccountStatus'
import ButtonShare from 'components/elements/ButtonShare/ButtonShare'
import ToggleNightMode from 'components/elements/ToggleNightMode/ToggleNightMode'
import Logo from 'components/interface/Logo/Logo'
import Img from 'lib/react/Img/Img'
import useDelayedActiveState from 'lib/react/hooks/useDelayedActiveState'
import styles from './Hero.module.scss'
import useHeroAnimation from './hooks/useHeroAnimation'

const sizesBg = [150, 200, 300]
const sizesChar = [150, 200, 300]

/**
 * The burger menu `Hero`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Hero (props) {
  const { isActive } = props
  const { setIsBurgerMenuOpen } = useRootContext()
  const sceneRef = useRef()
  const isSceneActive = useDelayedActiveState(isActive, 0.01, 0)
  const isLogoActive = useDelayedActiveState(isActive, 0.25, 0)

  // The hero animation
  useHeroAnimation(sceneRef, isSceneActive)

  /**
   * Handle close burger
   */
  const handleCloseBurgerMenu = useCallback(() => {
    setIsBurgerMenuOpen(false)
  }, [setIsBurgerMenuOpen])

  return (
    <div className={styles.container}>
      <div ref={sceneRef} className={styles.scene}>
        <div data-bg className={styles.item1}>
          <Img src="img/ui/hero/bg.webp" sizes={sizesBg} path="" />
        </div>
        <div className={styles.sceneGradientTop} />
        <div className={styles.heroTitle}>
          <Logo.Stacked
            className={styles.heroLogo}
            isActive={isLogoActive}
            isBeta={constants.IS_BETA}
          />
        </div>
        <div data-p className={styles.item4}>
          <Img src="img/ui/hero/3.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item5}>
          <Img src="img/ui/hero/4.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item3}>
          <Img src="img/ui/hero/2.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item8}>
          <Img src="img/ui/hero/7.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item7}>
          <Img src="img/ui/hero/6.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item9}>
          <Img src="img/ui/hero/8.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item6}>
          <Img src="img/ui/hero/5.webp" sizes={sizesChar} path="" />
        </div>
        <div data-p className={styles.item2}>
          <Img src="img/ui/hero/1.webp" sizes={sizesChar} path="" />
        </div>
        <div className={styles.sceneGradientBottom} path="" />
      </div>
      <div className={styles.header}>
        <Button
          type="symbol"
          icon="arrow_left"
          color="b"
          size="standard"
          useTooltip={true}
          title="Close"
          onClick={handleCloseBurgerMenu}
        />
        <div className={styles.options}>
          <ToggleNightMode
            useLabel={false}
            type="symbol"
            size="standard"
            color="c"
          />
          <ButtonShare />

          <ButtonAccountStatus className={styles.signIn} color="a" />
        </div>
      </div>
    </div>
  )
}

/** @type {object} */
Hero.propTypes = {
  isActive: PropTypes.bool
}

/** @type {object} */
Hero.defaultProps = {
  isActive: true
}

// Memoize
export default memo(Hero)
